export const KEY_CODES = {
	BACKSPACE: 8,
	ENTER: 13,
	ESC: 27,
	DOWN_ARROW: 40,
	UP_ARROW: 38,
	LEFT_ARROW: 37,
	RIGHT_ARROW: 39,
};
